import CustomAccordionActions from "./CustomAccordionActions";
import Note from "./Note";

export default function CustomNotesAccordionDetails({
  data,
  handleEdit,
  handleOnClickPin,
  notePermissionsHook,
}) {
  const noteContent = data?.content;
  return (
    <div
      className="note-wrapper flex w-full flex-col gap-2 bg-white p-4"
      style={{ contain: "layout paint style" }}
    >
      <CustomAccordionActions
        data={data}
        handleEdit={handleEdit}
        handleOnClickPin={handleOnClickPin}
        notePermissionsHook={notePermissionsHook}
      />
      <Note content={noteContent} />
    </div>
  );
}
